import { lazy } from 'react';
import { Outlet } from 'react-router';

import { PipelineType, UserRoleEnum } from 'src/utils/enumerations';

import { AuthGuard } from 'src/auth';
import { AppLayout } from 'src/layout';

import { PipelineProvider } from 'src/components/upload-table';

import RoleGuard from 'src/auth/RoleGuard';

const ErrorPage = lazy(() => import('src/pages/ErrorPage'));
const HomePage = lazy(() => import('src/pages/HomePage'));
const SalesSummaryPage = lazy(() => import('src/pages/sales/SummaryPage'));
const ComplianceSummaryPage = lazy(() => import('src/pages/compliance/SummaryPage'));
const ServicingSummaryPage = lazy(() => import('src/pages/servicing/SummaryPage'));
const SalesPipelineWrapper = () => (
  <PipelineProvider pipelineType={PipelineType.Sales}>
    <Outlet />
  </PipelineProvider>
);

const CompliancePipelineWrapper = () => (
  <PipelineProvider pipelineType={PipelineType.Hmda}>
    <Outlet />
  </PipelineProvider>
);

const ServicingPipelineWrapper = () => (
  <PipelineProvider pipelineType={PipelineType.Servicing}>
    <Outlet />
  </PipelineProvider>
);

export const dashboardRoutes = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <AppLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '/sales',
        element: (
          <RoleGuard role={UserRoleEnum.Sales}>
            <SalesPipelineWrapper />
          </RoleGuard>
        ),
        children: [
          { path: '', element: <HomePage /> },
          { path: 'summary/:id', element: <SalesSummaryPage /> },
        ],
      },
      {
        path: '/compliance',
        element: (
          <RoleGuard role={UserRoleEnum.Compliance}>
            <CompliancePipelineWrapper />
          </RoleGuard>
        ),
        children: [
          { path: '', element: <HomePage /> },
          { path: 'summary/:id', element: <ComplianceSummaryPage /> },
        ],
      },
      {
        path: '/servicing',
        element: (
          <RoleGuard role={UserRoleEnum.Servicing}>
            <ServicingPipelineWrapper />
          </RoleGuard>
        ),
        children: [
          { path: '', element: <HomePage /> },
          {
            path: 'summary/:id',
            element: <ServicingSummaryPage />,
          },
        ],
      },
      {
        path: '/403',
        element: <ErrorPage status={403} />,
      },
    ],
  },
];
